export enum BatchProcessModuleType {
    KMZExcelImport = 1,
    DORemainderExcelImport = 2,
    DOFailed = 3,
    SuspendRemainderExcelImport = 4,
    ProductAndPriceChange = 5,
    paymentArrangement = 6,
    RemainderMail = 7,
    suspendCustomers = 8,
    BulkRevoke = 9,
    BulkLegalCollection = 10,
    BulkRevertLegalCollection = 11,
    UploadFsanNumber = 12,
    RevokePromotion =13
}
